export const model = {
  Code: '',
  Description: '',
  Branch: '',
};
